/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { BomCostingService } from "../../service/BomCostingService";
import { Panel } from "primereact/panel";
import { Knob } from "primereact/knob";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputNumber } from "primereact/inputnumber";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import StyleMinute from "../../models/StyleMinute";
import { useParams } from "react-router-dom";

const StyleMinutes = () => {
    const toast = useRef<any>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [originalValues, setOriginalValues] = useState<StyleMinute>();
    const { styleCode } = useParams();

    useEffect(() => {
        if (!styleCode) { return; }

        BomCostingService.getMinutesByStyleCode(styleCode).then(data => {
            // Update form field value
            if (data) {
                setValues(data);

                let originalValue: StyleMinute = {
                    style_Cd: styleCode,
                    style_StoneMinutes: data.style_StoneMinutes,
                    style_BraidMinutes: data.style_BraidMinutes,
                    style_SewMinutes: data.style_SewMinutes,
                    style_SubPressMinutes: data.style_SubPressMinutes,
                    style_SubPrintMinutes: data.style_SubPrintMinutes,
                    style_CreateMinutes: data.style_CreateMinutes,
                    style_ApplyMinutes: data.style_ApplyMinutes,
                    style_TotalSam: data.style_TotalSam
                };
                setOriginalValues(originalValue)
            }
        });
    }, [styleCode]);

    const defaultValues: StyleMinute = {
        style_Cd: "",
        style_StoneMinutes: null,
        style_BraidMinutes: null,
        style_SewMinutes: null,
        style_SubPressMinutes: null,
        style_SubPrintMinutes: null,
        style_CreateMinutes: null,
        style_ApplyMinutes: null,
        style_TotalSam: null
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        setValue
    } = useForm<StyleMinute>({ defaultValues });

    const onSubmit: SubmitHandler<StyleMinute> = (value) => {
        if (!styleCode) { return; }

        setIsEditing(!isEditing);
        value.style_Cd = styleCode;
        save(value);
    };

    const setValues = (value: StyleMinute) => {
        setValue('style_StoneMinutes', value.style_StoneMinutes);
        setValue('style_BraidMinutes', value.style_BraidMinutes);
        setValue('style_SewMinutes', value.style_SewMinutes);
        setValue('style_SubPressMinutes', value.style_SubPressMinutes);
        setValue('style_SubPrintMinutes', value.style_SubPrintMinutes);
        setValue('style_CreateMinutes', value.style_CreateMinutes);
        setValue('style_ApplyMinutes', value.style_ApplyMinutes);
        setValue('style_TotalSam', value.style_TotalSam);
    }

    const save = (value: StyleMinute) => {
        if (!styleCode) { return; }

        if (isEditing) {
            try {
                BomCostingService.updateMinutesByStyleCode(value).then((data) => {
                    if (data) {
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Minutes Updated', life: 3000 });
                        let originalValue: StyleMinute = {
                            style_Cd: styleCode,
                            style_StoneMinutes: data.style_StoneMinutes,
                            style_BraidMinutes: data.style_BraidMinutes,
                            style_SewMinutes: data.style_SewMinutes,
                            style_SubPressMinutes: data.style_SubPressMinutes,
                            style_SubPrintMinutes: data.style_SubPrintMinutes,
                            style_CreateMinutes: data.style_CreateMinutes,
                            style_ApplyMinutes: data.style_ApplyMinutes,
                            style_TotalSam: data.style_TotalSam
                        };
                        setOriginalValues(originalValue);
                        setValues(originalValue);
                    }
                });
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Exception', detail: 'Failed to Update Minutes', life: 3000 });
                return null;
            }
        }
    }

    const getFormErrorMessage = (name: keyof StyleMinute) => {
        return errors[name] ? (
            <small className="p-error">{errors[name]?.message}</small>
        ) : (
            <small className="p-error">&nbsp;</small>
        );
    };

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Panel header="Minutes" className="mb-2 -ml-2">
                    <div className="flex flex-wrap justify-between">
                        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-wrap justify-between" autoComplete="off">
                            <div className="flex flex-column align-items-center ml-3">
                                <Controller
                                    name="style_SubPressMinutes"
                                    control={control}
                                    rules={{ validate: (value) => (value === 0 || value) && (value <= 200) || "The value must be equal or less than 200", }}
                                    render={({ field }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs mb-2">
                                                Sublimation Press Minutes
                                            </label>

                                            <Knob
                                                id={field.name}
                                                name="field.name"
                                                value={originalValues?.style_SubPressMinutes ?? 0}
                                                readOnly
                                            />
                                            {isEditing && (
                                                <InputNumber
                                                    id={field.name}
                                                    inputRef={field.ref}
                                                    value={field.value}
                                                    onBlur={field.onBlur}
                                                    onChange={(e) => field.onChange(e.value ?? 0)}
                                                    minFractionDigits={0}
                                                    maxFractionDigits={2}
                                                    useGrouping={false}
                                                />
                                            )}
                                        </>
                                    )}
                                />
                                {getFormErrorMessage("style_SubPressMinutes")}

                            </div>
                            <div className="flex flex-column align-items-center ml-3">
                                <Controller
                                    name="style_SubPrintMinutes"
                                    control={control}
                                    rules={{ validate: (value) => (value === 0 || value) && (value <= 200) || "The value must be equal or less than 200", }}
                                    render={({ field }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs mb-2">
                                                Sublimation Print Minutes
                                            </label>

                                            <Knob
                                                id={field.name}
                                                name="field.name"
                                                value={originalValues?.style_SubPrintMinutes ?? 0}
                                                min={0}
                                                max={200}
                                                readOnly
                                            />
                                            {isEditing && (
                                                <InputNumber
                                                    id={field.name}
                                                    inputRef={field.ref}
                                                    useGrouping={false}
                                                    value={field.value}
                                                    onBlur={field.onBlur}
                                                    onChange={(e) => field.onChange(e.value ?? 0)}
                                                    minFractionDigits={0}
                                                    maxFractionDigits={2}
                                                />
                                            )}
                                        </>
                                    )}
                                />

                                {getFormErrorMessage("style_SubPrintMinutes")}
                            </div>
                            <div className="flex flex-column align-items-center ml-3">
                                <Controller
                                    name="style_TotalSam"
                                    control={control}
                                    rules={{ validate: (value) => (value === 0 || value) && (value <= 200) || "The value must be equal or less than 200", }}
                                    render={({ field }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs mb-2">
                                                Sew Minutes/Total SAM
                                            </label>

                                            <Knob
                                                id={field.name}
                                                name="field.name"
                                                value={originalValues?.style_TotalSam ?? 0}
                                                min={0}
                                                max={200}
                                                readOnly
                                            />
                                            {isEditing && (
                                                <InputNumber
                                                    id={field.name}
                                                    inputRef={field.ref}
                                                    value={field.value}
                                                    useGrouping={false}
                                                    onBlur={field.onBlur}
                                                    onChange={(e) => field.onChange(e.value ?? 0)}
                                                    minFractionDigits={0}
                                                    maxFractionDigits={2}
                                                />
                                            )}
                                        </>
                                    )}
                                />

                                {getFormErrorMessage("style_TotalSam")}
                            </div>
                            <div className="flex flex-column align-items-center ml-3">
                                <Button
                                    type="button"
                                    onClick={handleSubmit(onSubmit)}
                                    className="mt-2"
                                    icon={isEditing ? 'pi pi-save' : 'pi pi-pencil'}
                                    title={isEditing ? 'Save' : 'Edit'}
                                    text
                                    severity="info"
                                    rounded
                                    outlined
                                />
                                {isEditing && (
                                    <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" onClick={() => {
                                        setIsEditing(!isEditing);
                                        if (originalValues != null) {
                                            setValues(originalValues);
                                        }
                                    }} />
                                )}
                            </div>
                        </form>
                    </div>
                </Panel>
            </div>
        </div>
    )
}

export default StyleMinutes;